import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import {
  useGetProductDetailsQuery,
  useUploadProductImageMutation,
  useUpdateProductWithPositionMutation
} from '../../slices/productsApiSlice';
import moment from 'moment';
const ProductEditScreenOffice = () => {
  const { id: productId } = useParams();
  //NEW-VENDEUR
  const [name, setName] = useState('');

  const [type, setType] = useState(0);
  const [proprio, setProprio] = useState('');

  const [price, setPrice] = useState(0);
  //selim
  const [priceEur, setPriceEur] = useState(0);
  const [priceDol, setPriceDol] = useState(0);
  const [date, setDate] = useState('');
  const [position, setPosition] = useState(0); // New state for position

  const [image, setImage] = useState('');
  const [brand, setBrand] = useState('');
  const [category, setCategory] = useState('');
  const [countInStock, setCountInStock] = useState(0);
  const [description, setDescription] = useState('');

  const {
    data: product,
    isLoading,
    refetch,
    error,
  } = useGetProductDetailsQuery(productId);



  const [uploadProductImage, { isLoading: loadingUpload }] =
    useUploadProductImageMutation(); 
    const [updateProduct, { isLoading: loadingUpdate }] =
    useUpdateProductWithPositionMutation();
  const navigate = useNavigate();

  
  useEffect(() => {
    if (product) {
      setName(product.name);
      setType(product.type);
      setProprio(product.proprio);
      setPrice(product.price);
      //selim
      setPriceEur(product.priceEur);
      setPriceDol(product.priceDol);
      setDate(moment(product.date).format('YYYY-MM-DD'));
      setPosition(product.position); // Set the position from the product data
      setImage(product.image);
      setBrand(product.brand);
      setCategory(product.category);
      setCountInStock(product.countInStock);
      setDescription(product.description);
    }
  }, [product]);

  
  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateProduct({
        productId,
        name,
        type,
        proprio,
        price,
        //selim
        priceEur,
        priceDol,
        date: moment(date).toDate(),
        image,
        brand,
        category,
        description,
        countInStock,
        position,
      });
      toast.success('Product updated');
      refetch();
      navigate('/');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };
  

  
  const uploadFileHandler = async (e) => {
    const formData = new FormData();
    formData.append('image', e.target.files[0]);
    try {
      const res = await uploadProductImage(formData).unwrap();
      toast.success(res.message);
      setImage(res.image);
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };
  

  return (
    <>
      <Link to='/office/productlist' className='btn btn-light my-3'>
        Retour
      </Link>
      <FormContainer>
        <h1>Modifier un produit</h1>
        {loadingUpdate && <Loader />}
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant='danger'>{error}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId='name' className='my-2'>
              <Form.Label>Nom</Form.Label>
              <Form.Control
                type='name'
                placeholder='Entrer le nom'
                value={name}
                onChange={(e) => setName(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='type' className='my-2'>
              <Form.Label>Type</Form.Label>
              <Form.Control
                type='type'
                placeholder='Entrer le type'
                value={type}
                onChange={(e) => setType(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='proprio' className='my-2'>
              <Form.Label>Proprietaire</Form.Label>
              <Form.Control
                type='proprio'
                placeholder='Entrer le proprietaire'
                value={proprio}
                onChange={(e) => setProprio(e.target.value)}
              ></Form.Control>
            </Form.Group>

            

            {/* selim  */}
            <Form.Group controlId='price' className='my-2'>
              <Form.Label>Prix en TND</Form.Label>
              <Form.Control
                type='number'
                placeholder='Entrer le prix'
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              ></Form.Control>
            </Form.Group>
            {/* selim  */}
             <Form.Group controlId='priceEur' className='my-2'>
              <Form.Label>Prix en EUR</Form.Label>
              <Form.Control
                type='number'
                placeholder='Entrer le prix'
                value={priceEur}
                onChange={(e) => setPriceEur(e.target.value)}
              ></Form.Control>
            </Form.Group> 
             {/* selim  */}
             <Form.Group controlId='priceDol' className='my-2'>
              <Form.Label>Prix en USD</Form.Label>
              <Form.Control
                type='number'
                placeholder='Entrer le prix'
                value={priceDol}
                onChange={(e) => setPriceDol(e.target.value)}
              ></Form.Control>
            </Form.Group> 



            <Form.Group controlId='image'>
              <Form.Label>Image</Form.Label>
              <Form.Control
                type='text'
                placeholder="Entrer le lien de l'image"
                value={image}
                onChange={(e) => setImage(e.target.value)}
              ></Form.Control>
              <Form.Control
                label='Choose File'
                onChange={uploadFileHandler}
                type='file'
              ></Form.Control>
            </Form.Group>
            {loadingUpload && <Loader />} 




            <Form.Group controlId='brand' className='my-2'>
              <Form.Label>Marque</Form.Label>
              <Form.Control
                type='text'
                placeholder='Entrer la marque'
                value={brand}
                onChange={(e) => setBrand(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='countInStock' className='my-2'>
              <Form.Label>Disponibilité au stock</Form.Label>
              <Form.Control
                type='number'
                placeholder='Entrer la disponibilité de stock'
                value={countInStock}
                onChange={(e) => setCountInStock(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='category' className='my-2'>
              <Form.Label>Catégorie</Form.Label>
              <Form.Control
                type='text'
                placeholder='Entrer la catégorie'
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='description' className='my-2'>
              <Form.Label>Description</Form.Label>
              <Form.Control
                type='text'
                placeholder='Entrer la description'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='date'>
              <Form.Label>Date</Form.Label>
              <Form.Control
                type='date'
                placeholder='Enter date'
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </Form.Group>
            
            <Form.Group controlId='position' className='my-2'>
              <Form.Label>Position</Form.Label>
              <Form.Control
                type='number'
                placeholder='Enter position'
                value={position}
                onChange={(e) => setPosition(e.target.value)}
              />
            </Form.Group>

            <Button
              type='submit'
              variant='primary'
              className='my-2'
              style={{ marginTop: '1rem' }}
            >
              Mettre à jour
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default ProductEditScreenOffice;
